import { unmonitoredBinLevel } from '~/parcels/index.js';
import { LitEntity, html, css } from '../js/utility/lit-entity';
import './parcel-loader';

class UnmonitoredBinProfile extends LitEntity {
  static get styles() {
    return css`
      :host {
        display: flex;
        justify-content: center;
      }

      parcel-loader {
        --parcel-width: 80px;
        --parcel-height: 200px;
      }
    `;
  }

  render() {
    const passThroughProperties = {
      href: this.href,
      standAlone: true,
    };

    return html`
      <parcel-loader
        .parcel=${unmonitoredBinLevel}
        .passThroughProperties=${passThroughProperties}
      ></parcel-loader>
    `;
  }
}

window.customElements.define('unmonitored-bin-profile', UnmonitoredBinProfile);
